import { Link } from 'react-router-dom';
import ProductCard from '../product-card/product-card.component';
import './category-preview.styles.scss';

const CategoryPreview = ({title, products}) => {
    return(
        <div className='category-preview-container'>
            <h2>
                <Link className='title' to={title}>{title.toUpperCase()} <span style={{fontSize: '14px'}}>(see all)</span></Link>
            </h2>
            <div className='preview'>
                {
                    products.filter((_, index) => index < 4)
                    .map((product) => <ProductCard key={product.id} product={product} />)
                }
            </div>

        </div>
    )
}

export default CategoryPreview;